import React, { useState } from "react"
import { LoadingTail } from "../core/LoadingTail"
import { SingleLayerCommand } from "../singleLayer/SingleLayerCommand";
import { SingleLayerSettings } from "../singleLayer/SingleLayerSettings";
import { SingleLayerTitle } from "../singleLayer/SingleLayerTitle";
import { SingleLayerDeckGLH3 } from "../H3/SingleLayerDeckGLH3";
import { H3LayerTitle } from "./H3LayerTitle";
import { getLayerData } from "../singleLayer/singleLayerService"; import { use } from "react";
import { useEffect } from "react";

export function LayerH3() {
    //const [data, setData] = useState({
    //    composite_layer: "H3Exposure",
    //    geoserver_layer_name: "h3-z4-sumatra",
    //    geoserver_workspace: "sumatra",
    //    is_raster: false,
    //    is_time: false,
    //    description: "exposure aggregated on h3 cell",
    //    id: 60,
    //    color_map_default: null
    //});
    const id = 60
    const [data, setData] = useState(undefined)
    const isH3 = true
    const [colorMapName, setColorMapName] = useState('blues')
    const [colorMapOpacity, setColorMapOpacity] = useState(100)
    const [mapTheme, setMapTheme] = useState('basic-v2/{z}/{x}/{y}@2x.png')
    const [isView3d, setIsView3d] = useState(false)
    const [colorMaps, setColorMaps] = useState([])
    const [zoom, setZoom] = useState('z4')
    const [height, setHeight] = useState('population')
    const [color, setColor] = useState('landslide')
    const [viewState, setViewState] = useState({
        longitude: 105.64,
        latitude: -1.48,
        zoom: 4.6,
        pitch: 60,
        maxZoom: 17,
        minZoom: 4.6,
        bearing: 0
    });

    useEffect(() => {
        getLayerData(id).then(async (response) => {
            if (response) {
                let { data } = response
                setData(data)
            }
        })
    }, [])

    return (
        <>
            <SingleLayerDeckGLH3
                data={data}
                viewState={viewState}
                setViewState={setViewState}
                isView3d={isView3d}
                mapTheme={mapTheme}
                colorMapName={colorMapName}
                colorMapOpacity={colorMapOpacity}
                color={color}
                height={height}
                zoom={zoom}
            ></SingleLayerDeckGLH3>

            <SingleLayerCommand
                viewState={viewState}
                setViewState={setViewState}
                isView3d={isView3d}
                setIsView3d={setIsView3d}
                isTime={false}
                isH3={isH3}
            ></SingleLayerCommand>

            <SingleLayerSettings
                data={data}
                setData={setData}
                viewState={viewState}
                setViewState={setViewState}
                mapTheme={mapTheme}
                setMapTheme={setMapTheme}
                colorMaps={colorMaps}
                colorMapName={colorMapName}
                setColorMapName={setColorMapName}
                colorMapOpacity={colorMapOpacity}
                setColorMapOpacity={setColorMapOpacity}
                isH3={isH3}
                zoom={zoom}
                setZoom={setZoom}
                height={height}
                setHeight={setHeight}
                color={color}
                setColor={setColor}
            ></SingleLayerSettings>

            <H3LayerTitle />

            <LoadingTail />
        </>
    )
}